const UiScopeInputPropsOption = {
  placeholder: { type: Object },
  modelValue: { type: Object, required: true },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  width: { type: [Number, String], default: 264 },
  size: { type: String, default: "default" },
  name: { type: String }
};
const UiScopeInputEmits = {
  "update:modelValue": (_ev) => true,
  "change": (_ev) => true,
  "clear": (_ev) => true,
  "input": (_ev) => true,
  "focus": (_ev) => true,
  "blur": (_ev) => true
};

export { UiScopeInputEmits, UiScopeInputPropsOption };
//# sourceMappingURL=index.mjs.map
